import { AST } from '@handlebars/parser';
import { getStatements } from './getStatements';
import { getStatement } from './getStatement';
import { getHandlebarsSnippetTagFromStatement } from './getHandlebarsSnippetTagFromStatement';

export const getHandlebarsSnippetTagFromString = (
  content: string,
): AST.MustacheStatement | null => {
  const statements = getStatements(content);
  const statement = getStatement(statements);
  return getHandlebarsSnippetTagFromStatement(statement);
};
